import { createAction } from 'redux-actions';

import { saveDisplaySettings } from './save-display-settings';

const updateCalendarEventFiltersAction = createAction('UPDATE_CALENDAR_EVENT_FILTERS');

export const updateCalendarEventFilters =
  (calendarEventFilters: Array<SelectOption<string>>, username: string | null) =>
  (dispatch: Function, getState: Function) => {
    dispatch(updateCalendarEventFiltersAction({ calendarEventFilters, username }));
    saveDisplaySettings(getState());
  };
